import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import Block from "../../Block/Block";

function DJIVisualizer() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>DJI Visualizer</BlockTitle>
        </BlockContent>
        <BlockContent>
          <BlockText>...</BlockText>
        </BlockContent>
      </Block>

      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockText>
              ...
          </BlockText>
        </BlockContent>
        <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/DJIInterface.webp'} title="AI Meets Art: The Ernst Abbe University as a Work of Art in Kandinsky’s Style"/>
        </BlockContent>
      </Block>

      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/eah_digital.webp'} title="Between Reality and Virtuality: The Department of Electrical Engineering and Information Technology Goes Digital"/>
        </BlockContent>
        <BlockContent>
        <video width="100%"controls >
              <source src="https://potechius.com/Videos/LNdW_Demo.mp4" type="video/mp4"/>
        </video>
        </BlockContent>
      </Block>

      <Footer/>
    </div>
  );
}

export default DJIVisualizer;